import { catchError } from "rxjs/operators";
import { ResolveFn, Router } from "@angular/router";
import { AccountService } from "../services/account.service";
import { inject } from "@angular/core";
import { EMPTY } from "rxjs";
import { Account } from "../types/account.type";

export const accountByLoginCodeResolver: ResolveFn<Account> = (route) => {
  const router = inject(Router);
  const { code, id: caseId } = route.params;
  const redirectUrl = encodeURIComponent(`/case/${caseId}`);
  if (!code && caseId) {
    router.navigate(["login"], { queryParams: { redirectUrl } });
    return EMPTY;
  }
  return inject(AccountService)
    .getAccountByLoginCode(code)
    .pipe(
      catchError(() => {
        router.navigate(["login"], { queryParams: { redirectUrl } });
        return EMPTY;
      }),
    );
};
